//=================================\\
// Contact Form Settings \\
//=================================\\

export default function contactForm() {
	if ($('.ac-contact__form-box select').length >= 1) {
		const queryString = window.location.search,
			urlParams = new URLSearchParams(queryString),
			selectForm = urlParams.get('select-form');

		if (selectForm != null) {
			$('.ac-contact__form-box select option').each(function () {
				let val = $(this).val().toLowerCase().replace(/ /g, "_");

				if (selectForm == val) {
					$(this).attr('selected', 'selected');
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/contact-form.js